import Dashboard from '@/modules/reports/dashboard/Dashboard.vue';
import InsightsHome from '@/modules/insights/InsightsHome.vue';
import TrialSummaryMessage from '@/modules/onboarding/components/TrialSummaryMessage.vue';
import HeaderComponent from '@/components/Header/HeaderComponent.vue';
import vuetify from '@/main';
angular.module('leanlaw').directive('dashboardDir', function () {
  return {
    restrict: 'E',
    ...vuetify(Dashboard)
  };
});
angular.module('leanlaw').directive('insightsHomeDir', function () {
  return {
    restrict: 'E',
    ...vuetify(InsightsHome)
  };
});
angular.module('leanlaw').directive('trialSummaryMessage', function () {
  return {
    restrict: 'E',
    ...vuetify(TrialSummaryMessage)
  };
});
angular.module('leanlaw').directive('headerComponent', function () {
  return {
    restrict: 'E',
    ...vuetify(HeaderComponent)
  };
});